import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
import { CHECKOUT_URL, PRICE, TOTAL_VALUE } from '../data/product';
const included = ['6 volumes · 90 two-page sessions', '60, 75 and 90-minute versions of every session', '24 worksheets + 6 pocket field cards', '5 bonuses, incl. the Season Route Planner', 'Soft-ball & hard-ball tracks + wet-weather swaps', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-cream-light text-ink" data-id="element-232" data-mp="1rut0zotkvy23">
      <div className="mx-auto max-w-2xl px-5 py-16 sm:py-20" data-id="element-233" data-mp="25pv6wbyfdnew">
        <div className="text-center" data-id="element-234" data-mp="20rjupuknr0ti">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-grass-deep" data-id="element-235" data-mp="3h7eeegj1gcj9">Complete package</p>
          <h2 id="pricing-heading" className="mt-3 font-display text-3xl text-ink sm:text-5xl" data-id="element-236" data-mp="3c8jufb9c4hxk">
            Your whole season, planned
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-cream-dark bg-white shadow-soft" data-id="element-237" data-mp="3w1jhi6uv8s0y">
          <div className="bg-field px-5 py-5 text-center" data-id="element-238" data-mp="4v8ishdbw3cs">
            <h3 className="font-display text-xl font-extrabold tracking-tight text-cream sm:text-2xl" data-id="element-239" data-mp="9tjw522u0vzr">
              No-Queue Cricket: Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-semibold uppercase tracking-widest text-willow" data-id="element-240" data-mp="3d9h89gkk0e0q">6 Volumes + 5 Bonuses</p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-241" data-mp="3i8tqtp4e6yxi">
            <div id="offer" className="scroll-mt-4 overflow-hidden rounded-2xl bg-field px-2 pb-1 pt-4" data-id="element-242" data-mp="3i5plgof6xx59">
              <ProductVisual seal={false} lazy data-id="element-243" data-mp="3rxv95lyetsen" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-244" data-mp="3rz6dbmvrp26a">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink" data-id="element-245" data-mp="2ugdbhmc1hl1w">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-grass-deep" data-id="element-246" data-mp="2zfzphxzoz5br">
                    <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-247" data-mp="2mhrufshspo58" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cream-dark pt-6 text-center" data-id="element-248" data-mp="318qxknzv3khf">
              <p className="text-[13px] text-ink-soft" data-id="element-249" data-mp="2w83agder7nsh">
                Total value <span className="line-through" data-id="element-250" data-mp="28h7dl1vfy2ed">${TOTAL_VALUE} USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-ink" data-id="element-251" data-mp="23jfi5xvl7y5f">
                <span className="mt-2.5 font-display text-3xl font-extrabold" data-id="element-252" data-mp="2ifwvuvr91ov5">$</span>
                <span className="font-display text-[56px] font-black leading-[0.9] tracking-tight sm:text-7xl" data-id="element-253" data-mp="2dh3fmvkkvjra">{PRICE}</span>
                <span className="mt-3 text-[13px] font-semibold text-ink-muted" data-id="element-254" data-mp="3tutvezl27wgr">USD</span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-255" data-mp="3ox1tdcqpatyu">
                <span className="rounded bg-willow px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-willow-ink" data-id="element-256" data-mp="anciifus8qt">
                  Save ${TOTAL_VALUE - PRICE}
                </span>
                <span className="rounded border border-cream-dark px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-257" data-mp="3nfcz4osokn5u">
                  One-time payment
                </span>
                <span className="rounded border border-cream-dark px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-258" data-mp="j0d4yyw58ifk">
                  No app, no subscription
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-259" data-mp="a7rzullfqa97">
                Get No-Queue Cricket — only ${PRICE}
              </CtaButton>

              <p className="mt-3 text-xs text-ink-soft" data-id="element-260" data-mp="e7seo7cg4ngs">Backed by the 7-day money-back guarantee</p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-261" data-mp="11xwk8k972xaf">
                <li className="flex items-center gap-1.5" data-id="element-262" data-mp="3f78vcmg73tje">
                  <LockIcon className="h-4 w-4 text-grass-deep" aria-hidden="true" data-id="element-263" data-mp="3f8tp49uor8g7" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-264" data-mp="3592qbvz3e7ab">
                  <ZapIcon className="h-4 w-4 text-grass-deep" aria-hidden="true" data-id="element-265" data-mp="359m89coqsvoc" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-266" data-mp="1t5frlx0qxbg">
                  <ShieldCheckIcon className="h-4 w-4 text-grass-deep" aria-hidden="true" data-id="element-267" data-mp="1uqabbjc2g9b" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-soft" data-id="element-268" data-mp="3o5u79yr5wab7">
          Price in USD. You&apos;ll be charged the equivalent in your local currency, whatever it is.
        </p>
      </div>
    </section>;
}